import type { FavoriteProduct } from '../../types/types'

export const isFavoriteCheck = (
	product: FavoriteProduct,
	favorites?: FavoriteProduct[]
): boolean => {
	return favorites
		? favorites.some(
				({ ref, color }) => ref === product.ref && color === product.color
			)
		: false
}
